import { spawn } from 'redux-saga/effects';

import twoFactorSagas from './twoFactor/twoFactorSagas';

export default function* sagas() {
	yield spawn(twoFactorSagas);
}
